import React, { Component } from 'react';
import PropTypes from 'prop-types'

import BookingFlowSignUp from './BookingFlowSignUp'
import BookingFlowSignIn from './BookingFlowSignIn'


export default class BookingFlowSignUpIn extends Component {

	state = {
		mode: 'signin'
	}

	render() {
		return (
			<div className="booking-flow-sign-in">
				{this.state.mode === 'signin' ? this.renderSignIn() : this.renderSignUp()}
			</div>
		)
	}

	renderSignIn = () => {
		return(
			<BookingFlowSignIn
				onSignUpClick={this.onSignUpClick} />
		)
	}

	renderSignUp = () => {
		return(
			<BookingFlowSignUp
				onSignInClick={this.onSignInClick} />
		)
	}

	onSignUpClick = () => {
		this.setState({mode: 'signup' })
	}

	onSignInClick = () => {
		this.setState({mode: 'signin' })
	}
}

BookingFlowSignUpIn.contextTypes = { t: PropTypes.func }


// WEBPACK FOOTER //
// ./src/components/bookingflow/BookingFlowSignUpIn.js